<div class="sidebar fixed" *ngIf="expanded">
  <div class="menuList">
    <div class="menuHeader">
      <ng-container *ngFor="let menu of menuList">
        <div
          class="py-2 d-flex hoverMenulist"
          [routerLink]="menu.route"
          routerLinkActive="active"
          #route="routerLinkActive"
          [class.active]="route.isActive" style="cursor: pointer;"
        >
          <a class="menu-item d-flex align-items-center"></a>
          <img loading="lazy" class="menu-img px-2" [src]="menu.img" alt="" />
          <span class="menuTitle">{{ menu.title }}</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
  
